import React from 'react';
import { motion } from 'framer-motion';
import { PhoneFrame } from './PhoneFrame';
import { screens } from '../data/screens';
export function RoundSpinner() {
  return <section className="relative overflow-hidden bg-kitty-dark py-20 text-white lg:py-28" data-id="element-271" data-mp="2nb06d3tsgcpu">
      {/* A bit of the wheel's own colour, kept faint */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" data-id="element-272" data-mp="2x8eg6kl7i396">
        <div className="absolute left-[8%] top-[15%] h-64 w-64 rounded-full bg-[#EA4334]/10 blur-3xl" data-id="element-273" data-mp="319q66r7zsqhw" />
        <div className="absolute bottom-[10%] right-[12%] h-72 w-72 rounded-full bg-[#4285F4]/10 blur-3xl" data-id="element-274" data-mp="3679ivmp1kv7q" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 sm:px-8" data-id="element-275" data-mp="3b02rilnmsnp3">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20" data-id="element-276" data-mp="3fydwoj2zea0z">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} className="order-2 lg:order-1" data-id="element-277" data-mp="3kwxmiukp45ym">
            <p className="mb-4 text-sm font-black uppercase tracking-widest text-kitty-yellow" data-id="element-278" data-mp="1oinn2mpji0ke">
              Not strictly accounting
            </p>
            <h2 className="mb-5 text-3xl font-black leading-[1.05] tracking-tight md:text-4xl lg:text-5xl" data-id="element-279" data-mp="1eimzgokn0yae">
              The important stuff is sorted. Now, whose round is next?
            </h2>
            <p className="max-w-md text-lg leading-relaxed text-gray-400 lg:text-xl" data-id="element-280" data-mp="277kf0jxgsgzg">
              Can't decide who's buying? Give the wheel a spin and let KittyPot
              choose.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          rotate: -4,
          y: 24
        }} whileInView={{
          opacity: 1,
          rotate: 0,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6,
          ease: [0.22, 1, 0.36, 1]
        }} className="order-1 mx-auto w-full max-w-[320px] lg:order-2 lg:max-w-[340px]" data-id="element-281" data-mp="1xgzcileo6sb9">
            <PhoneFrame screen={screens.spinner} shadow="xl" data-id="element-282" data-mp="ja310b458tn1" />
          </motion.div>
        </div>
      </div>
    </section>;
}